import React from 'react'
import HomepageBanner from '../components/HomepageBanner'
import TradingPlatformsComponents from '../components/TradingPlatformsComponent'
import Seperator from '../components/Seperator'
import TradingPlarformsCards from '../components/TradingPlarformsCards'
import Cta from '../components/Cta'

const TradingPlatforms = () => {
    return (
        <>
            <HomepageBanner pageName="tradingplatforms" />
            <TradingPlatformsComponents />
            <Seperator />
            <TradingPlarformsCards />
            <Cta />
        </>
    )
}

export default TradingPlatforms